interface QualitySubMenuProps {
    title: string;
    displayPercent: string;
    value: string;
    display: boolean;
}

export const QualitySubMenuItems: QualitySubMenuProps[] = [
    {
        title: 'Best',
        displayPercent: '90%',
        value: 'best',
        display: true,
    },
    {
        title: 'Good',
        displayPercent: '85%',
        value: 'good',
        display: true,
    },
    {
        title: 'Eco',
        displayPercent: '80%',
        value: 'eco',
        display: true,
    },
];
